<template>
  <div class="hatful">
    <menuBox :step="1"></menuBox>
    <div class="hatful-box">
      <div class="banner-text">
        <div class="text">When we love the world we live in it</div>
        <div class="title">
          Download App and Join Us
        </div>
        <div class="imgs">
          <img src="../assets/tb1.png" alt="">
          <img src="../assets/tb2.png" alt="">
        </div>
      </div>
    </div>
    <div class="recommend-box">
      <div class="title">Recommend Short Dramas</div>
      <div class="text">Gather the world's best drama</div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/recommend1.png" alt="">
          <div>
            <p>Thorns of Rose</p>
            <span>After three years of wrongful suffering, she believed her release was a fresh start, but the
              all-powerful CEO dragged her back into despair...</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/recommend2.png" alt="">
          <div>
            <p>Mommy, we need daddy</p>
            <span>The preview is out! Stay tuned for more!My wife walks away from my child's near-murder, and years later
              I return in glory!</span>
          </div>
        </div>
      </div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/recommend3.png" alt="">
          <div>
            <p>Spoiled by the boss</p>
            <span>It's been three years, it's time to pay off this debt, I'm tired, leave me alone!</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/recommend4.png" alt="">
          <div>
            <p>The Female CEO Turned Janitor</p>
            <span>who would have thought that the cleaning aunt before our eyes is actually a female CEO with a net worth
              of trillions...</span>
          </div>
        </div>
      </div>
    </div>
    <footerBox :step="1"></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      type: 1
    };
  },
  mounted() { },
  methods: {
    changeType(val) {
      this.type = val
    }
  },
};
</script>

<style lang="less" scoped>
.hatful {
  position: relative;
  background: #191A20;
}

.hatful-box {
  margin: 0 305px;
  background-image: url(../assets/swiper-1.png);
  height: 800px;
  background-size: 100% 100%;
  position: relative;
  text-align: center;

  .banner-text {
    padding-top: 80px;

    .text {
      margin: 0 auto 37px;
      max-width: 1000px;
      font-size: 80px;
      font-family: Roboto, Roboto;
      font-weight: 900;
      color: #FFFFFF;
      line-height: 94px;
    }

    .title {
      margin: 0 auto 54px;
      max-width: 1000px;
      font-size: 40px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 32px;
    }

    .imgs {
      img {
        margin-right: 50px;
        width: 241px;
        height: 86px;
      }

      img:nth-child(2) {
        margin-right: 0;
      }
    }
  }
}

.recommend-box {
  padding: 120px 305px;

  .title {
    margin-bottom: 10px;
    font-size: 52px;
    font-family: Roboto, Roboto;
    font-weight: 900;
    color: #FFFFFF;
    line-height: 61px;
    text-align: center;
  }

  .text {
    margin-bottom: 106px;
    font-size: 32px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 32px;
    text-align: center;
  }

  .itemBox {
    display: flex;

    .item {
      display: flex;
      width: 50%;
      margin-right: 180px;
      margin-bottom: 70px;

      img {
        width: 128px;
        height: 171px;
        margin-right: 30px;
      }

      p {
        margin-bottom: 14px;
        font-size: 26px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 30px;
      }

      span {
        font-size: 17px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 26px;
      }
    }

    .item:nth-child(2) {
      margin-right: 0;
    }
  }
}
</style>
